const getters = {
    employees: (state) => state.employees,
    employeeid: (state) => state.employeeid,
    employeeDocs: (state) => state.employeeDocs,
    employeeDocId: (state) => state.employeeDocId,
    loading: state => state.loading
};

export default getters;